import { createStore, createEffect, createEvent } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { StatementsApi, type DownloadStatementRequest } from '@shared/api';

const downloadStatementEffect = createEffect((request: DownloadStatementRequest) => StatementsApi.download(request));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(downloadStatementEffect.pending, (_, data) => data)
  .on(downloadStatementEffect.fail, () => false)
  .on(downloadStatementEffect.done, () => false)
  .reset(clearEvent);

const $loadingIds = createStore<string[]>([])
  .on(downloadStatementEffect, (state, data) => (state.includes(data.id) ? state : [...state, data.id]))
  .on(downloadStatementEffect.done, (state, { params }) => state.filter((id) => id !== params.id))
  .on(downloadStatementEffect.fail, (state, { params }) => state.filter((id) => id !== params.id))
  .reset(clearEvent);

downloadStatementEffect.done.watch((result) => FileUtils.downloadFile(result.result, `Statement - ${result.params.id}`));
downloadStatementEffect.fail.watch(() => $notificationStore.events.setError('Something went wrong while downloading Statements. Please try again.'));

export const $downloadStatementStore = {
  events: {
    downloadStatement: downloadStatementEffect,
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    loadingIds: $loadingIds,
  },
};
